import { Col } from 'antd';
import OptionTypeField from './OptionTypeField';

const OptionTypeMultiSelectField = ({ prefix, disabled = false }: { prefix: string; disabled?: boolean }) => (
    <Col lg={24} xs={24}>
        <OptionTypeField disabled={disabled} name={`${prefix}.options`} />
    </Col>
);

export default OptionTypeMultiSelectField;
